import { AuthClient, NotesClient, TodosClient } from '../web-api-client';
import { authorizedHttp } from './http';

// baseUrl rỗng: SPA và API cùng nguồn khi chạy thật, còn lúc phát triển thì máy chủ dev của React
// chuyển tiếp /api sang ASP.NET (xem setupProxy.js).
export const authApi = new AuthClient('', authorizedHttp);
export const todosApi = new TodosClient('', authorizedHttp);
export const notesApi = new NotesClient('', authorizedHttp);
